import { HttpEventType } from '@angular/common/http';
import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { finalize, Observable, Subject, Subscription, tap } from 'rxjs';
import { Question } from 'src/app/core-module/models/Audits/question';
import { BasicResult } from 'src/app/core-module/models/basic-result';
import { Toastr } from 'src/app/core-module/models/Utils/toastr';
import { AuditService } from 'src/app/core-module/services/audit.service';
import { ToastrService } from 'src/app/core-module/services/toastr.service';
import { UtilService } from 'src/app/core-module/services/util.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-question-photo',
    templateUrl: './question-photo.component.html',
    styleUrl: './question-photo.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class QuestionPhotoComponent {
  @Input() currentQuestion: Question;
  @Input() showWebcam: boolean;
  @Output() currentQuestionChange = new EventEmitter<Question>();

  public uploadProgress: number | null = null;
  public uploadSub: Subscription;
  public isBluebird: boolean = false;

  private trigger: Subject<void> = new Subject<void>();

  public get triggerObservable(): Observable<void> {
    return this.trigger.asObservable();
  }


  constructor(private auditService: AuditService, private toast: ToastrService, private util:UtilService) {
      this.isBluebird = environment.blueBird;
  }

  takePicture() {
    this.trigger.next();
  }

  public handleImage(webcamImage: string): void {
    let upload$ = this.auditService.uploadPhoto(webcamImage).pipe(
      finalize(() => {
        this.uploadProgress = null;
      })
    );
    this.uploadSub = upload$.subscribe((event:any) => {
      if (event.type == HttpEventType.UploadProgress) {
        this.uploadProgress = Math.round(100 * (event.loaded / event.total!));
      }
      if (event.type == HttpEventType.Response) {
        this.currentQuestion.CompletionInfo.Photos.push(event.body!.toString());
        this.currentQuestionChange.emit(this.currentQuestion);
      }
    });

    /*this.currentQuestion.CompletionInfo.Photos.push(webcamImage.imageAsDataUrl);
    this.currentQuestionChange.emit(this.currentQuestion);*/
  }

  photoSrc(GUID: string): string {
    return `${environment.apiUrl}audits/gettempphoto/` + GUID;
  }
  altPhotoSrc(GUID:string):string{
  return `${environment.apiUrl}audits/getaltphoto/` + GUID;
  }

  public removePhoto(Photo: string) {

    this.auditService.removePhoto(Photo);
    var idx = this.currentQuestion.CompletionInfo.Photos.findIndex((e) => e == Photo);
    if (idx != -1){
      this.auditService.removePhoto(Photo).pipe(
        tap((res:BasicResult) => {
          if(res.IsError){
            this.toast.addToastr(new Toastr({Type: 4, Message: "Unable to remove photo, please try again."}));
          }else{
            this.toast.addToastr(new Toastr({Type: 1, Message: "Photo removed."}));
          }
        })
      ).subscribe();
      this.currentQuestion.CompletionInfo.Photos.splice(idx,1);
      this.currentQuestionChange.emit(this.currentQuestion);
    }
    /*
    let idx = this.currentQuestion.CompletionInfo.Photos.findIndex(e => e == Photo);
    if (idx != -1) {
      this.currentQuestion.CompletionInfo.Photos.splice(idx, 1);
      this.currentQuestionChange.emit(this.currentQuestion);
    }*/
  }


}
